class Subright {
  constructor(
    rightsCategoryID,
    description,
    descriptionHash,
    id,
    learnMores,
    organizations,
    title,
    titleHash
  ) {
    this.rightsCategoryID = rightsCategoryID;
    this.description = description;
    this.descriptionHash = descriptionHash;
    this.id = id;
    this.learnMores = learnMores;
    this.organizations = organizations;
    this.title = title;
    this.titleHash = titleHash;
  }
}

export default Subright;
